import Athletes from 'pageCores/athletes'
import { getStaticFunctionsWithLocale } from 'utils/internationalization'
export const { getStaticPaths, getStaticProps } = getStaticFunctionsWithLocale('/athletes')
export default Athletes
